"use client"

import React from "react"

const ContactUs = () => {
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    countryCode: "+971",
  })

  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState("")
  const [successMessage, setSuccessMessage] = React.useState("")
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const dropdownRef = React.useRef(null)

  const countries = [
    { code: "+971", flag: "🇦🇪", name: "AE" },
    { code: "+966", flag: "🇸🇦", name: "SA" },
    { code: "+974", flag: "🇶🇦", name: "QA" },
    { code: "+968", flag: "🇴🇲", name: "OM" },
    { code: "+973", flag: "🇧🇭", name: "BH" },
    { code: "+965", flag: "🇰🇼", name: "KW" },
    { code: "+20", flag: "🇪🇬", name: "EG" },
    { code: "+962", flag: "🇯🇴", name: "JO" },
    { code: "+44", flag: "🇬🇧", name: "GB" },
    { code: "+1", flag: "🇺🇸", name: "US" },
    { code: "+61", flag: "🇦🇺", name: "AU" },
    { code: "+90", flag: "🇹🇷", name: "TR" },
    { code: "+49", flag: "🇩🇪", name: "DE" },
    { code: "+33", flag: "🇫🇷", name: "FR" },
    { code: "+39", flag: "🇮🇹", name: "IT" },
  ]

  const selectedCountry =
    countries.find(c => c.code === formData.countryCode) || countries[0]

  React.useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleCountrySelect = code => {
    setFormData({ ...formData, countryCode: code })
    setIsDropdownOpen(false)
  }

  // ✅ الفانكشن المعدلة مع معالجة أفضل للأخطاء
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setErrorMessage("")
    setSuccessMessage("")
    
    console.log('🚀 Sending data:', formData);

    try {
      const response = await fetch("http://localhost:5000/api/send-data", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      console.log('📥 Response status:', response.status);
      
      const result = await response.json();
      console.log('📦 Response data:', result);
      
      if (response.ok && result.success) {
        setSuccessMessage(
          "Thank you! Your message has been sent successfully. We will contact you soon."
        );
        // مسح الفورم بعد النجاح
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
          countryCode: "+971",
        });
      } else {
        setErrorMessage(result.message || "Failed to send message");
      }
    } catch (error) {
      console.error('❌ Fetch error:', error);
      setErrorMessage("Failed to send message. Please check your connection.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      id="ContactUs"
      className="px-4 py-16 sm:py-20 lg:py-28 bg-gradient-to-br from-[#020817] via-[#041E2F] to-[#000000] overflow-visible min-h-screen flex flex-col justify-center"
      style={{
        fontFamily: "'Inter', sans-serif",
        scrollMarginTop: "160px",
        paddingBottom: "80px",
      }}
    >
      <div id="our-presence" style={{ scrollMarginTop: "160px" }} />
      <div className="max-w-7xl mx-auto w-full">

        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Book a Free Consultation
          </h2>
          <p className="text-gray-300 text-base sm:text-lg md:text-xl max-w-3xl mx-auto">
            Transform your healthcare business with cutting-edge technology solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-16">

          {/* العمود الأيسر (المعلومات) */}
          <div className="lg:col-span-2 space-y-8">

            <div>
              <h3
                className="text-2xl sm:text-3xl font-bold mb-3"
                style={{
                  background: "linear-gradient(135deg, #06b6d4, #10b981)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Send us a Message
              </h3>
              <p className="text-gray-300 text-sm sm:text-base">
                Get in touch with our healthcare technology experts.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">

              <div className="group flex items-start gap-4 p-5 rounded-2xl bg-white/4 backdrop-blur-sm border border-white/10 hover:bg-white/6 transition-all">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-cyan-500/10 flex-shrink-0">
                  <img src="/299087_marker_map_icon.svg" className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-white font-semibold text-sm mb-1.5">Address</h4>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    Bear Investments Fund – Burdub Block -B 3003, 3rd Floor, Alqouz 3, Dubai , UAE
                  </p>
                </div>
              </div>

              <div className="group flex items-start gap-4 p-5 rounded-2xl bg-white/4 backdrop-blur-sm border border-white/10 hover:bg-white/6 transition-all">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-emerald-500/10 flex-shrink-0">
                  <img src="/6296671_microsoft_office_office365_outlook_icon.svg" className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-white font-semibold text-sm mb-1.5">Mail</h4>
                  <a 
                    href="mailto:support@kayan-healthcare.com"
                    className="text-gray-300 text-sm hover:text-cyan-400 transition-colors block mb-0.5"
                  >
                    support@kayan-healthcare.com
                  </a>
                  <a 
                    href="mailto:contact@kayan-healthcare.com"
                    className="text-gray-300 text-sm hover:text-cyan-400 transition-colors block"
                  >
                    contact@kayan-healthcare.com
                  </a>
                </div>
              </div>

              <a
                href="https://www.linkedin.com/company/kayan-healthcare-technologies"
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-start gap-4 p-5 rounded-2xl bg-white/4 backdrop-blur-sm border border-white/10 hover:bg-white/6 transition-all"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-blue-500/10 flex-shrink-0">
                  <img src="/4102586_applications_linkedin_social_social media_icon.svg" className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="text-white font-semibold text-sm mb-1.5">LinkedIn</h4>
                  <p className="text-gray-300 text-sm">Kayan Healthcare Technologies</p>
                </div>
              </a>

            </div>
          </div>

          {/* عمود الفورم (الأيمن) - ✅ لف كل شي بـ form tag */}
          <div className="lg:col-span-3">
            <form 
              onSubmit={handleSubmit}
              className="p-7 sm:p-9 rounded-3xl bg-black/25 backdrop-blur-xl border border-white/10 shadow-2xl"
            >

              <div className="space-y-6">

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Name *"
                    required
                    className="w-full px-6 py-4 rounded-full bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-400 text-base"
                  />

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="E-mail *"
                    required
                    className="w-full px-6 py-4 rounded-full bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-400 text-base"
                  />
                </div>

                <div className="grid grid-cols-[130px_1fr] gap-6">

                  <div ref={dropdownRef} className="relative">
                    <button
                      type="button"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      className="w-full px-4 py-4 rounded-full bg-white text-gray-800 font-medium text-base focus:outline-none focus:ring-2 focus:ring-cyan-400 flex items-center justify-between"
                    >
                      <span className="flex items-center gap-1">
                        <span>{selectedCountry.flag}</span>
                        <span>{selectedCountry.code}</span>
                      </span>
                      <svg
                        className={`w-4 h-4 transition-transform ${isDropdownOpen ? "rotate-180" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>

                    {isDropdownOpen && (
                      <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-2xl shadow-2xl border border-gray-200 max-h-60 overflow-y-auto z-50">
                        {countries.map(country => (
                          <button
                            key={country.code}
                            type="button"
                            onClick={() => handleCountrySelect(country.code)}
                            className={`w-full px-4 py-3 text-left text-sm hover:bg-cyan-50 flex items-center gap-2 transition-colors ${
                              formData.countryCode === country.code
                                ? "bg-cyan-100 text-cyan-600 font-medium"
                                : "text-gray-700"
                            }`}
                          >
                            <span>{country.flag}</span>
                            <span className="font-medium">{country.name}</span>
                            <span className="text-gray-500">{country.code}</span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Phone *"
                    required
                    className="w-full px-6 py-4 rounded-full bg-white text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-cyan-400 text-base"
                  />

                </div>

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Your Message *"
                  rows={5}
                  required
                  className="w-full px-6 py-4 rounded-2xl bg-white text-gray-900 placeholder-gray-500 resize-none focus:outline-none focus:ring-2 focus:ring-cyan-400 text-base"
                />

                {/* ✅ غيرت type من button لـ submit */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-4 px-6 text-base sm:text-lg font-semibold text-white bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full hover:from-cyan-400 hover:to-blue-500 transition-all disabled:opacity-60 shadow-lg flex items-center justify-center gap-2"
                >
                  {isSubmitting ? "Sending..." : "Send Message"}

                  {!isSubmitting && (
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  )}
                </button>

              </div>

              {successMessage && (
                <div className="mt-5 p-4 rounded-xl bg-green-500/10 border border-green-500/20 text-green-400 text-sm sm:text-base">
                  {successMessage}
                </div>
              )}
              {errorMessage && (
                <div className="mt-5 p-4 rounded-xl bg-red-500/10 border border-red-500/20 text-red-400 text-sm sm:text-base">
                  {errorMessage}
                </div>
              )}

            </form>
          </div>

        </div>

      </div>
    </section>
  )
}

export default ContactUs